export const PRODUCT_TYPE_SUPERLIKE = 'superlike';
export const PRODUCT_TYPE_BOOST = 'boost';
export const PRODUCT_TYPE_SUPERBOOST = 'super_boost';

export const productInfoMapping = {
  [PRODUCT_TYPE_BOOST]: {
    intlId: 'ICU.boostCount',
    product: 'boost',
  },
  [PRODUCT_TYPE_SUPERBOOST]: {
    intlId: 'ICU.superBoostCount',
    product: 'superboost',
  },
  [PRODUCT_TYPE_SUPERLIKE]: {
    intlId: 'ICU.superlikeCount',
    product: 'superlike',
  },
};
